/**
 * @packageDocumentation
 * @module f1/adt
 */

export interface Clone {
  /**
   * Create a new (deep) copy with JSON#parse and JSON#stringify of an object
   *
   * @public
   * @function f1.clone
   * @param value
   * @example
   *
   * ```ts
   * const u = [1, [2, 5], 3, 4];
   * const rtn = mirror(u);
   * rtn !== [1, [2, 5], 3, 4]
   * rtn !== u
   * rtn[1] !== u[1]
   * ```
   */
  <VALUE>(value: VALUE): VALUE;
}

/**
 * @see Clone
 */
export default (u: unknown) => {
  try {
    return JSON.parse(JSON.stringify(u));
  } catch (e) {
    return u;
  }
};
